var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout column justify-center align-center",staticStyle:{"min-height":"100%"}},[_c('h1',{staticClass:"flex x12 mt-10 text-center"},[_vm._v("BAS-IP UKEY labels")]),_c('div',{staticClass:"pa-10 mt-10 white elevation-3"},[_c('div',{staticClass:"text-center title"},[_vm._v(" Forbidden, you don't have access to this page ")])])])
}]

export { render, staticRenderFns }